export default "__VITE_ASSET__D2_vYgjd__"